const normalizeName = (value: string): string =>
  value.trim().replace(/\s+/g, ' ');

const getFirstName = (value: string): string => {
  const normalized = normalizeName(value);
  if (!normalized) return '';
  const [firstName = ''] = normalized.split(' ');
  return firstName;
};

export const compareNamesByFirstName = (
  leftName: string,
  rightName: string,
  locale: string = 'nl-NL'
): number => {
  const collator = new Intl.Collator(locale, { sensitivity: 'base', numeric: true });

  const firstNameCompare = collator.compare(getFirstName(leftName), getFirstName(rightName));
  if (firstNameCompare !== 0) return firstNameCompare;

  return collator.compare(normalizeName(leftName), normalizeName(rightName));
};

